module.exports = __webpack_public_path__ + "media/images/games/fifa-21/logo-fe17669dbe5024b6637339360afa74fc.png";